const contactInfo = {
    sporti1: {
        title: {
            en: 'SPORTI 1',
            kn: 'ಸ್ಪೋರ್ಟಿ 1'
        },
        location: "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7776.0547219230775!2d77.612095!3d12.970101!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1715a47fbf91%3A0x105bdbe2d51128a2!2sSenior%20Police%20Officer's%20Research%20and%20Training%20Institute%20(SPORTI)!5e0!3m2!1sen!2sin!4v1715542033130!5m2!1sen!2sin",
        info: [
            {
                icon: 'geo-alt-fill',
                title: {
                    en: 'ADDRESS',
                    kn: 'ವಿಳಾಸ'
                },
                desc: {
                    en: '#1,Prim Rose road, Ashok Nagar, Bengaluru 560025',
                    kn: '#1, ಪ್ರೈಮ್ ರೋಸ್ ರಸ್ತೆ, ಅಶೋಕ್ ನಗರ, ಬೆಂಗಳೂರು 560025'
                }
            },
            {
                icon: 'telephone-fill',
                title: {
                    en: 'PHONE',
                    kn: 'ದೂರವಾಣಿ'
                },
                desc: '+91 8277945903'
            },
            {
                icon: 'envelope-fill',
                title: {
                    en: 'EMAIL',
                    kn: 'ಇಮೇಲ್'
                },
                desc: 'sportikarnataka@gmail.com'
            }
        ]
    },
    sporti2: {
        title: {
            en: 'SPORTI 2',
            kn: 'ಸ್ಪೋರ್ಟಿ 2'
        },
        location: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3887.999525107927!2d77.6096316!3d12.9718819!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae1680e94f6af3%3A0xe9ac024d24f7a3ec!2sKSRP%20TRAINING%20AND%20RESEARCH%20CENTRE!5e0!3m2!1sen!2sin!4v1715541912383!5m2!1sen!2sin',
        info: [
            {
                icon: 'geo-alt-fill',
                title: {
                    en: 'ADDRESS',
                    kn: 'ವಿಳಾಸ'
                },
                desc: {
                    en: '26, Magrath Road, Ashok Nagar, Bengaluru 560025',
                    kn: '26, ಮಾಗ್ರತ್ ರಸ್ತೆ, ಅಶೋಕ್ ನಗರ, ಬೆಂಗಳೂರು 560025'
                }
            },
            {
                icon: 'telephone-fill',
                title: {
                    en: 'PHONE',
                    kn: 'ದೂರವಾಣಿ'
                },
                desc: '+91 9480800826'
            },
            {
                icon: 'envelope-fill',
                title: {
                    en: 'EMAIL',
                    kn: 'ಇಮೇಲ್'
                },
                desc: 'sporti2gov@gmail.com'
            }
        ]
    }
}

export default contactInfo;
